// src/components/Navbar.js
import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";

const NAV_ITEMS = [
  { to: "home", label: "Home" },
  { to: "about", label: "About" },
  { to: "projects", label: "Projects" },
  { to: "contact", label: "Contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-dusk-950/70 backdrop-blur-md border-b border-white/5 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex justify-between items-center">
        <Link
          to="home"
          smooth={true}
          duration={600}
          className="font-display font-bold text-lg tracking-tight cursor-pointer select-none text-shadow"
        >
          alexander<span className="text-ember">.lasson</span>
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              spy={true}
              smooth={true}
              duration={600}
              offset={-40}
              activeClass="!text-white after:!scale-x-100"
              className="relative text-sm font-medium text-white/80 hover:text-white cursor-pointer transition-colors text-shadow
                         after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-full after:bg-ember
                         after:origin-left after:scale-x-0 after:transition-transform after:duration-300"
            >
              {item.label}
            </Link>
          ))}
          <a
            href="https://github.com/AlexanderLasson"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/80 hover:text-white transition-colors text-lg text-shadow"
            aria-label="GitHub"
          >
            <i className="fab fa-github"></i>
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden text-white/80 hover:text-white text-xl p-1"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          <i className={`fas ${open ? "fa-xmark" : "fa-bars"}`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          open ? "max-h-64" : "max-h-0"
        }`}
      >
        <div className="px-6 pt-4 pb-6 flex flex-col gap-4 bg-dusk-950/95">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              smooth={true}
              duration={600}
              offset={-40}
              onClick={() => setOpen(false)}
              className="text-white/70 hover:text-white cursor-pointer font-medium"
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
